export var ITextElement;
(function (ITextElement) {
    let ITextElementStyle;
    (function (ITextElementStyle) {
        /**
         * Return an instance of ITextElementStyle with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ITextElementStyle.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(ITextElementStyle = ITextElement.ITextElementStyle || (ITextElement.ITextElementStyle = {}));
    /**
     * TextElement.TextDecorator is to be deprecated, please use TextDecorator in the future
     */
    let TextDecorator;
    (function (TextDecorator) {
        TextDecorator["TEXT_DECORATOR_UNKNOWN"] = "TEXT_DECORATOR_UNKNOWN";
        /**
         * SECTION_HEADER, PAGE_HEADER, DISPLAY_M, DISPLAY_L, DISPLAY_XL
         * don't have emphasis.
         */
        TextDecorator["EMPHASIS"] = "EMPHASIS";
        TextDecorator["LINK"] = "LINK";
        TextDecorator["STRIKE_THROUGH"] = "STRIKE_THROUGH";
    })(TextDecorator = ITextElement.TextDecorator || (ITextElement.TextDecorator = {}));
    /**
     * Return an instance of ITextElement with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ITextElement.build = (partial) => (Object.assign({ suffix_c_t_a_on_click: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(ITextElement || (ITextElement = {}));
